import useBasketBase from 'commerceAPI/hooks/useBasket';

export const useBasket = (opts = {}) => {
	const useBaseBasket = useBasketBase(opts);

	return {
		...useBaseBasket
	};
};
